import * as React from 'react';
import { SVGProps } from 'react';

const IconSearchStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.05 15.463a7.5 7.5 0 1 1 1.414-1.414l6.542 6.542-1.415 1.415-6.542-6.543ZM15 9.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
    />
  </svg>
);
export default IconSearchStrokedSizeM;
